import { Navigate, Outlet } from 'react-router-dom';
import {isUserLoggedIn, getUserType } from '../config/userSession';

const ProtectedAdminRoutes = () => {
return (
    isUserLoggedIn() && getUserType() === 'Admin' ? <Outlet/> : <Navigate to='/login'/>
  )
}

export default ProtectedAdminRoutes;